import queryStringSerializer from '@shared/queryStringSerializer';

const apiAdminRoutes = {
  building: buildingId => `/api/admin/buildings/${buildingId}`,
  buildingLink: '/api/admin/buildings/link',
  buildingListings: (buildingId, page = 1, query = '', statuses = []) => {
    const params = {
      query,
      page,
      statuses,
    };
    const queryString = queryStringSerializer(params);

    return `/api/admin/buildings/${buildingId}/listings?${queryString}`;
  },
  buildingMetadataFile: '/api/admin/building_metadata_files',
  buildingMediaDirectory: '/api/admin/building_media_directories',
  buildingPhotosOrder: buildingId => `/api/admin/buildings/${buildingId}/photos/order`,
  buildingPhoto: (buildingId, buildingPhotoId) =>
    `/api/admin/buildings/${buildingId}/photos/${buildingPhotoId}`,
  buildingPhotosCreate: buildingId => `/api/admin/buildings/${buildingId}/photos`,
  buildingVideo: (buildingId, buildingVideoId) =>
    `/api/admin/buildings/${buildingId}/videos/${buildingVideoId}`,
  buildingVideoCreate: buildingId => `/api/admin/buildings/${buildingId}/videos`,
  buildingSearch: ({
    query = '',
    page = 1,
    spaceProviders = [],
    statuses = [],
    cities = [],
    states = [],
    countries = [],
    latitude = null,
    longitude = null,
    distance = null,
  }) => {
    const params = {
      query,
      page,
      space_providers: spaceProviders,
      statuses,
      cities,
      states,
      latitude,
      longitude,
      distance,
      countries,
    };

    const queryString = queryStringSerializer(params);

    return `/api/admin/buildings?${queryString}`;
  },
  buildingFilters: '/api/admin/filters/buildings',
  buildingUnlistedSpaces: (buildingId, page = 1, query) =>
    `/api/admin/buildings/${buildingId}/unlisted_spaces?query=${query}&page=${page}`,
  buildings: '/api/admin/buildings',
  companiesPlain: '/api/admin/companies',
  companies: (query, page = 1) => {
    const queryString = queryStringSerializer({ query, page });
    return `/api/admin/companies?${queryString}`;
  },
  fiberProviders: (query, page = 1) => {
    const queryString = queryStringSerializer({ query, page });
    return `/api/admin/fiber_providers?${queryString}`;
  },
  company: id => `/api/admin/companies/${id}`,
  vtsProperty: id => `/api/admin/vts_properties/${id}`,
  vtsSpace: vtsSpaceId => `/api/admin/vts_spaces/${vtsSpaceId}`,
  floorPlanCreate: '/api/admin/floor_plans',
  floorPlan: floorPlanId => `/api/admin/floor_plans/${floorPlanId}`,
  listing: listingId => `/api/admin/listings/${listingId}`,
  listings: '/api/admin/listings',
  listingPhoto: (listingId, listingPhotoId) =>
    `/api/admin/listings/${listingId}/photos/${listingPhotoId}`,
  listingPhotosOrder: listingId => `/api/admin/listings/${listingId}/photos/order`,
  listingPhotosCreate: listingId => `/api/admin/listings/${listingId}/photos`,
  listingPrices: listingId => `/api/admin/listings/${listingId}/prices`,
  listingVideo: (listingId, listingVideoId) =>
    `/api/admin/listings/${listingId}/videos/${listingVideoId}`,
  listingVideoCreate: listingId => `/api/admin/listings/${listingId}/videos`,
  listingVideoUpdate: (listingId, id) => `/api/admin/listings/${listingId}/videos/${id}`,
  listingRoomsCreate: listingId => `/api/admin/listings/${listingId}/rooms`,
  listingRoomsUpdate: (listingId, id) => `/api/admin/listings/${listingId}/rooms/${id}`,
  listingRoomsDelete: (listingId, id) => `/api/admin/listings/${listingId}/rooms/${id}`,
  listingSearch: ({
    query = '',
    sortBy = null,
    page = 1,
    spaceProviders = [],
    statuses = [],
    cities = [],
    states = [],
    countries = [],
  }) => {
    const params = {
      query,
      sort_by: sortBy,
      page,
      space_providers: spaceProviders,
      statuses,
      cities,
      states,
      countries,
    };

    const queryString = queryStringSerializer(params);

    return `/api/admin/listings?${queryString}`;
  },
  listingFilters: '/api/admin/filters/listings',
  listingMediaDirectory: '/api/admin/listing_media_directories',
  properties: id => `/api/admin/properties/${id}`,
  // FF Cleanup: amenities-data-tabs - roomMetadataFile will no longer be referenced
  roomMetadataFile: '/api/admin/room_metadata_files',
  spaceMetadataFile: '/api/admin/space_metadata_files',
  user: userId => `/api/admin/users/${userId}`,
  userFilters: '/api/admin/filters/users',
  userSearch: (query, page = 1, roles = []) => {
    const params = {
      query,
      page,
      roles,
    };
    const queryString = queryStringSerializer(params);

    return `/api/admin/users?${queryString}`;
  },
  users: '/api/admin/users',
  landlords: '/api/admin/landlords',
  landlord: id => `/api/admin/landlords/${id}`,
  landlordPhotoOrder: id => `/api/admin/landlords/${id}/photos/order`,
  landlordPhotoCreate: id => `/api/admin/landlords/${id}/photos`,
  landlordPhotoDelete: ({ id, landlordId }) => `/api/admin/landlords/${landlordId}/photos/${id}`,
  landlordPhotoUpdate: ({ id, landlordId }: { id: string; landlordId: string }) =>
    `/api/admin/landlords/${landlordId}/photos/${id}`,
  landlordVideoCreate: id => `/api/admin/landlords/${id}/videos`,
  landlordVideoUpdate: ({ id, landlordId }) => `/api/admin/landlords/${landlordId}/videos/${id}`,
  landlordVideoDelete: ({ id, landlordId }) => `/api/admin/landlords/${landlordId}/videos/${id}`,
} as const;

export default apiAdminRoutes;
